import React from 'react'
import Co2Score from './Co2Score'
import { useTranslation } from 'next-i18next'

type Co2ChartProps = {
  score: number
}

export default function Co2Chart({ score }: Co2ChartProps) {
  const { t } = useTranslation('originals/property')

  return (
    <div className="w-full">
      <div className="pb-4">
        <Co2Score score={score} />
      </div>
      <div className="grid grid-rows-7 gap-1">
        <div className="flex w-3/12 rounded-md bg-purple-300 px-2 py-0.5 text-xs text-white">
          <div>5</div>
          <div className="ml-auto font-bold">A</div>
        </div>
        <div className="flex w-4/12 rounded-md bg-purple-400 px-2 py-0.5 text-xs text-white">
          <div>6 à 10</div>
          <div className="ml-auto font-bold">B</div>
        </div>
        <div className="flex w-5/12 rounded-md bg-purple-500 px-2 py-0.5 text-xs text-white">
          <div>11 à 29</div>
          <div className="ml-auto font-bold">C</div>
        </div>
        <div className="flex w-6/12 rounded-md bg-purple-600 px-2 py-0.5 text-xs text-white">
          <div>30 à 49</div>
          <div className="ml-auto font-bold">D</div>
        </div>
        <div className="flex w-7/12 rounded-md bg-purple-700 px-2 py-0.5 text-xs text-white">
          <div>50 à 69</div>
          <div className="ml-auto font-bold">E</div>
        </div>
        <div className="flex w-8/12 rounded-md bg-purple-800 px-2 py-0.5 text-xs text-white">
          <div>70 à 99</div>
          <div className="ml-auto font-bold">F</div>
        </div>
        <div className="flex w-9/12 rounded-md bg-purple-900 px-2 py-0.5 text-xs text-white">
          <div>100</div>
          <div className="ml-auto font-bold">G</div>
        </div>
      </div>
      <div className="pt-1 text-xs font-thin text-neutralBlack">
        {t('dpeAndWorkSection.dpe.kgeqCO2')}
      </div>
    </div>
  )
}
